/**
 * @deprecated This component is not supported in Browser Extensions due to Chrome's security restrictions around remotely hosted code.
 * @see https://clerk.com/docs/references/browser-extensions/browser-security-restrictions
 */
export const GoogleOneTap = () => null;
